import * as React from 'react';

interface IRegionSelectedForm {
  regions: string;
}

class RegionSelected extends React.Component<IRegionSelectedForm> {

  public renderUkIcon = () => {
    return (
      <div className="icon-selected-container-uk">
        {/*<img src={require('./img/icon_uk_selected.svg')} alt="uk" className="cls-6"/>*/}
        <svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 95">
          <title>selected</title>
          <path className="cls-1" d="M39.5,18.47a23.06,23.06,0,0,0-9.92,7.16l9.92,5V18.47Z"/>
          <path className="cls-1" d="M65.45,25.61a23.14,23.14,0,0,0-9.95-7.16V30.58Z"/>
          <path className="cls-1" d="M55.5,62.55a23.72,23.72,0,0,0,10.14-7.4L55.5,50.09V62.55Z"/>
          <path className="cls-1" d="M29.4,55.14a23.64,23.64,0,0,0,10.1,7.4V50.09Z"/>
          <path className="cls-2"
                d="M64.14,32.5H56.69l10.09-5.29c-0.33-.46-0.82-1-1.18-1.48L55.5,30.58V18.45a21.92,21.92,0,0,
                          0-3-1v18h18a21.25,21.25,0,0,0-2-5.35Z"/>
          <path className="cls-2"
                d="M30,35.5H42.5v-18a22,22,0,0,0-3,1V30.58l-10.09-5a26.06,26.06,0,0,0-2.83,4.47l4.24,
                          2.41h-5.3a22.1,22.1,0,0,0-1,3H30Z"/>
          <path className="cls-2"
                d="M64.93,45.5H52.5v18a21.92,21.92,0,0,0,3-1V50.09l10.29,5.07a24.63,24.63,0,0,0,
                          2.77-4.32L64.14,48.5h5.47a21.8,21.8,0,0,0,1-3H64.93Z"/>
          <path className="cls-2"
                d="M42.5,46.56V45.5H24.43a21.49,21.49,0,0,0,1.92,5.4l4.46-2.4h7.45L28,53.7c0.32,0.47.83,
                          1,1.18,1.4l10.28-5V62.54a22,22,0,0,0,3,1v-17Z"/>
          <path className="cls-3" d="M30.81,48.5l-4.46,2.32A23,23,0,0,0,28,53.66L38.27,48.5H30.81Z"/>
          <path className="cls-3" d="M26.49,30.34a10.06,10.06,0,0,0-1,2.16h5.3Z"/>
          <path className="cls-3" d="M64.14,32.5l4.37-2.43a22.06,22.06,0,0,0-1.72-2.74L56.69,32.5h7.45Z"/>
          <path className="cls-3" d="M68.64,50.75a11.32,11.32,0,0,0,1-2.25H64.14Z"/>
          <path className="cls-3"
                d="M67.47,35.5h-15v-18a26.74,26.74,0,0,0-5-.53,26.58,26.58,0,0,0-5,.54v18h-18a19.64,19.64,0,0,
                          0-.57,5.17,27.26,27.26,0,0,0,.5,4.83H42.5v18a26.58,26.58,0,0,0,5,.54,26.74,26.74,0,0,0,
                          5-.53v-18H70.57a27.26,27.26,0,0,0,.5-4.83,19.64,19.64,0,0,0-.57-5.17h-3Z"/>
          <circle className="cls-4" cx="47.5" cy="40.59" r="36.4"/>
          <circle className="cls-4" cx="47.5" cy="40.23" r="33.54"/>
          <circle className="cls-6" cx="49.16" cy="81.86" r="10.95"/>
          <rect className="cls-2" x="44.37" y="80.28" width="11.5" height="3.24"
                transform="translate(-43.23 59.44) rotate(-45.01)"/>
          <rect className="cls-2" x="44.42" y="80.41" width="3.24" height="6.55"
                transform="translate(-45.69 57.08) rotate(-45.01)"/>
        </svg>
      </div>
    );
  }

  public render() {
    const { name } = this.props;
    let render;
    switch (name) {
      case 'uk':
        render = this.renderUkIcon();
        break;
    }
    return (
      <div className="destination-image">
        {render}
      </div>
    );
  }
}

export default RegionSelected;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/RegionSelect/RegionSelected.tsx